import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=77cafb78&"
import script from "./SelectItem.vue?vue&type=script&lang=js&"
export * from "./SelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77cafb78')) {
      api.createRecord('77cafb78', component.options)
    } else {
      api.reload('77cafb78', component.options)
    }
    module.hot.accept("./SelectItem.vue?vue&type=template&id=77cafb78&", function () {
      api.rerender('77cafb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/SelectItem.vue"
export default component.exports